import React, { useEffect, useState } from 'react';
import { Typography, Button, Box, TableHead, TableBody, TableCell, Table, TableRow, Hidden } from '@material-ui/core';
import { useTranslations } from 'utils/useTranslations';
import clsx from 'clsx';
import { useStoreState } from 'easy-peasy';
import { Link, useParams } from 'react-router-dom';

import { format, isValid } from 'date-fns';
import { AddPaymentModal } from 'components/Modals/AddPaymentModal';
import { roundTo2 } from 'utils/roundTo2';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { BillingPdf } from 'components/BillingPdf/BillingPdf';

import { CaseListItem } from '../PatientCases/types';
import { useStyles } from './styles';

const PatientBill = () => {
  const intl = useTranslations();
  const styles = useStyles();
  const { caseId } = useParams<{ caseId: string; patient: string }>();

  const caseItem: CaseListItem = useStoreState((state) => state.cases.getById(caseId));
  const patients: any = useStoreState((state) => state.patientsMap);

  const patient = patients?.[caseItem?.patientId];

  const [open, setOpen] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const toggleModal = () => setOpen((old) => !old);

  useEffect(() => {
    setPdfLoading(true);
    if (caseItem) {
      setTimeout(() => {
        setPdfLoading(false);
      }, 500);
    }
  }, [caseItem]);

  return (
    caseItem && (
      <>
        <Box className={styles.sectionHeader}>
          <Typography className={styles.sectionHeaderBold} variant="h5">
            {intl('patient.bills')} {isValid(new Date(caseItem.name)) ? format(new Date(caseItem.name), 'dd.MM.yyyy') : caseItem.name}
          </Typography>
        </Box>
        <Box className={clsx(styles.sectionHeader)}>
          <Typography className={styles.sectionSubHeader} variant="h5">
            {intl('patient.totalAmount')}: {roundTo2(caseItem.total)}
          </Typography>
          {pdfLoading ? (
            <>Cargando documento ...</>
          ) : (
            <PDFDownloadLink fileName={caseItem._id} document={<BillingPdf patient={patient} caseItem={caseItem} />}>
              {({ loading }) => (
                <Button fullWidth variant="contained" color="primary">
                  {loading ? 'Cargando documento ...' : '¡Descargar ahora!'}
                </Button>
              )}
            </PDFDownloadLink>
          )}
        </Box>
        <Box className={clsx(styles.sectionHeader)}>
          <Typography className={styles.sectionSubHeader} variant="h5">
            {intl('patient.totalAmountPaid')}
          </Typography>
          <Button variant="contained" onClick={toggleModal} color="primary">
            {intl('patient.addNewPayment')}
          </Button>
        </Box>
        <Table className={styles.table}>
          <TableHead>
            <TableCell className={styles.column}>{intl('shared.date')}</TableCell>
            <TableCell className={styles.column}>{intl('patient.accountNumber')}</TableCell>
            <TableCell className={styles.column}>{intl('patient.amount')}</TableCell>
            <Hidden smDown>
              <TableCell className={styles.column}>{intl('patient.registered')}</TableCell>
            </Hidden>
          </TableHead>
          <TableBody>
            {caseItem?.payments.map((paymentItem) => (
              <TableRow>
                <TableCell className={styles.column}>{format(paymentItem.createdAt, 'dd.MM.yyyy')}</TableCell>
                <TableCell className={styles.column}>{paymentItem.paymentNumber}</TableCell>
                <TableCell className={styles.column}> {roundTo2(paymentItem.amount)}</TableCell>
                <Hidden smDown>
                  <TableCell className={styles.column}>
                    <Link to={`/user/medical_professionals/profile/${paymentItem.createdBy._id}`}>
                      {paymentItem.createdBy?.firstName} {paymentItem.createdBy?.lastName}
                    </Link>
                  </TableCell>
                </Hidden>
              </TableRow>
            ))}
          </TableBody>
          <TableRow style={{ border: 'none' }}>
            <TableCell className={styles.column}>{intl('case.total_payment')}</TableCell>
            <TableCell className={styles.column} />
            <TableCell className={styles.column}>{roundTo2(caseItem.paidTotal)}</TableCell>
            <Hidden smDown>
              <TableCell className={styles.column} />
            </Hidden>
          </TableRow>
        </Table>
        <Box className={clsx(styles.sectionHeader, styles.sectionConent)}>
          <Typography className={styles.sectionSubHeader} variant="h5">
            {intl('patient.totalAmountToPay')}: {roundTo2(caseItem.total - caseItem.paidTotal)}
          </Typography>
        </Box>
        <AddPaymentModal open={open} onClose={toggleModal} />
      </>
    )
  );
};

export default PatientBill;
